<main lang="es-HN">
  @if (showHeader) {
  <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
  }

  <ng-container [ngTemplateOutlet]="heroBannerTemplate"></ng-container>

  @if (!isUserLoggedIn) {
  <ng-container [ngTemplateOutlet]="loginBannerTemplate"></ng-container>
  } @if (isLoading) {
  <ng-container [ngTemplateOutlet]="loadingTemplate"></ng-container>
  } @else if (vehiculos.length <= 0) {
  <ng-container [ngTemplateOutlet]="emptyStateTemplate"></ng-container>
  } @else {
  <ng-container [ngTemplateOutlet]="vehiclesSectionTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="actionButtonsTemplate"></ng-container>
  }
</main>

<!-- Templates -->
<ng-template #headerTemplate>
  <header
    class="bg-white flex gap-1 items-center py-6 px-4 border-b border-gray-200 sticky top-0 z-10"
  >
    <button
      (click)="goBack()"
      class="flex gap-4 items-center fs-condensed"
      [attr.aria-label]="'Volver atrás'"
      title="Volver"
    >
      <i class="pi pi-chevron-left text-gray-700" aria-hidden="true"></i>
      ATRÁS
    </button>
  </header>
</ng-template>

<ng-template #heroBannerTemplate>
  <section
    class="bg-[#5c697b] xl:h-52 flex flex-col xl:flex-row justify-between"
  >
    <div
      class="flex items-center gap-4 xl:pl-16 justify-center xl:justify-start"
    >
      <img
        src="/allas-icons/mi-garage.svg"
        alt="Icono de Mi Garaje"
        class="h-10 xl:h-20 w-auto"
        width="80"
        height="80"
        loading="eager"
      />
      <h1 class="p-6 text-white text-4xl xl:text-7xl font-black fs-condensed">
        MI GARAJE
      </h1>
    </div>
    <img
      src="/images/garage/cars-background.webp"
      alt="Fondo de vehículos en garaje"
      class="h-full object-cover"
      width="400"
      height="208"
      loading="lazy"
    />
  </section>
</ng-template>

<ng-template #loginBannerTemplate>
  <section
    class="bg-gradient-to-r from-[#d51322] to-[#b40919] text-white py-8 px-4"
  >
    <div class="flex flex-col items-center justify-between gap-12">
      <div class="flex flex-col items-center gap-8 xl:flex-row w-full px-8">
        <div class="flex gap-4 xl:flex-auto xl:w-3/4">
          <img
            src="/allas-icons/guard.svg"
            alt="Icono de seguridad"
            class="h-8 xl:h-12 w-auto"
            width="48"
            height="48"
            loading="eager"
          />
          <div class="flex flex-col">
            <h2 class="text-xl xl:text-3xl font-bold fs-condensed">
              ¡Inicia Sesión y Obtén Beneficios!
            </h2>
            <p class="text-sm xl:text-xl opacity-85 mt-2 fs-condensed">
              Guarda tus Vehículos, Gana Puntos y Más.
            </p>
          </div>
        </div>
        <button
          (click)="goToLogin()"
          class="hidden xl:block bg-white text-allasRed hover:bg-gray-100 px-12 py-3 w-full transition-colors xl:w-max fs-condensed"
          [attr.aria-label]="'Iniciar sesión'"
          title="Ingresar"
        >
          INGRESAR
        </button>
      </div>

      <div class="flex flex-col items-center xl:items-start">
        <div
          class="flex flex-col gap-4 xl:flex-row xl:justify-between w-full"
        >
          <ng-container
            [ngTemplateOutlet]="benefitItemTemplate"
            [ngTemplateOutletContext]="{
              text: 'Cotizaciones Rápidas y Precisas'
            }"
          ></ng-container>
          <div
            class="hidden xl:block w-px h-6 bg-white opacity-50"
            aria-hidden="true"
          ></div>
          <ng-container
            [ngTemplateOutlet]="benefitItemTemplate"
            [ngTemplateOutletContext]="{ text: 'Navegación Personalizada' }"
          ></ng-container>
          <div
            class="hidden xl:block w-px h-6 bg-white opacity-50"
            aria-hidden="true"
          ></div>
          <ng-container
            [ngTemplateOutlet]="benefitItemTemplate"
            [ngTemplateOutletContext]="{ text: 'Garaje Sincronizado' }"
          ></ng-container>
        </div>
      </div>

      <button
        (click)="goToLogin()"
        class="xl:hidden bg-white text-allasRed hover:bg-gray-100 px-12 py-3 w-full transition-colors xl:w-max fs-condensed"
        [attr.aria-label]="'Iniciar sesión'"
        title="Ingresar"
      >
        INGRESAR
      </button>
    </div>
  </section>
</ng-template>

<ng-template #benefitItemTemplate let-text="text">
  <div class="flex gap-3 items-center xl:flex-1 xl:justify-center">
    <img
      src="/allas-icons/circle-check-white.svg"
      alt="Beneficio incluido"
      class="h-6 xl:h-8 w-auto"
      width="32"
      height="32"
      loading="lazy"
    />
    <span class="xl:text-xl font-medium fs-condensed">
      {{ text }}
    </span>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="flex flex-col items-center justify-center py-16 px-4">
    <div class="w-16 h-16 rounded-full flex items-center justify-center mb-4">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-appBlack"
        aria-hidden="true"
      ></div>
    </div>
    <h2 class="text-xl font-bold text-gray-800 mb-2 fs-condensed">
      Cargando vehículos...
    </h2>
    <p class="text-gray-600 text-center fs-condensed">Espera un momento</p>
  </div>
</ng-template>

<ng-template #emptyStateTemplate>
  <div class="bg-gray-50 flex flex-col items-center justify-center pt-16">
    <div class="flex gap-4 items-center">
      <img
        src="/allas-icons/car-detailed.svg"
        alt="Sin vehículos guardados"
        class="h-8 w-auto"
        width="32"
        height="32"
        loading="eager"
      />
      <h2 class="text-2xl font-black fs-condensed">
        No tienes Vehículos Guardados
      </h2>
    </div>

    <p class="text-gray-600 text-center mb-6 mt-4 fs-condensed">
      Agrega tu primer Vehículo para encontrar los Repuestos que necesitas.
    </p>

    <div class="py-4">
      <button
        (click)="agregarVehiculo()"
        class="flex items-center gap-2 bg-appPrimary-500 hover:bg-blue-700 text-lg text-white fs-condensed px-4 py-2 transition-colors"
        [attr.aria-label]="'Agregar primer vehículo'"
        title="Agregar primer vehículo"
      >
        <lucide-icon
          [name]="plusIcon"
          class="w-5 h-5"
          aria-hidden="true"
        ></lucide-icon>
        AÑADIR PRIMER VEHÍCULO
      </button>
    </div>
  </div>
</ng-template>

<ng-template #vehiclesSectionTemplate>
  <section class="flex flex-col xl:flex-row gap-2 bg-gray-50 p-4 pt-8">
    <div class="flex flex-col gap-2 w-full xl:w-1/2">
      <h2 class="text-xl font-bold fs-condensed text-center">
        Actualmente comprando para mí:
      </h2>
      <div class="flex flex-col gap-1">
        @if (getVehiculoSeleccionado()) {
        <ng-container
          [ngTemplateOutlet]="vehicleCardTemplate"
          [ngTemplateOutletContext]="{
            vehiculo: getVehiculoSeleccionado(),
            isSelected: true
          }"
        ></ng-container>
        }
      </div>
    </div>

    <div
      class="w-px bg-appBlack opacity-30 hidden xl:block"
      aria-hidden="true"
    ></div>

    <div class="flex flex-col gap-2 w-full xl:w-1/2">
      <h2 class="text-xl font-bold fs-condensed text-center">
        Vehículos Guardados
      </h2>
      <div class="flex flex-col gap-1">
        @for (vehiculo of getAnotherVehicles(); track vehiculo.id) {
        <ng-container
          [ngTemplateOutlet]="vehicleCardTemplate"
          [ngTemplateOutletContext]="{ vehiculo: vehiculo, isSelected: false }"
        ></ng-container>
        }
      </div>
    </div>
  </section>
</ng-template>

<ng-template
  #vehicleCardTemplate
  let-vehiculo="vehiculo"
  let-isSelected="isSelected"
>
  <article
    class="bg-white p-2 border cursor-pointer grid grid-cols-12 gap-2 transition-all duration-300"
    [class.border-allasRed]="isSelected"
    [class.hover:border-allasRed]="!isSelected"
    (click)="isSelected ? null : seleccionarVehiculo(vehiculo)"
    [attr.aria-label]="'Seleccionar vehículo {{ vehiculo.alias }}'"
    title="Seleccionar vehículo"
  >
    <div class="col-span-1 flex items-center justify-center">
      <img
        src="/allas-icons/car-detailed.svg"
        alt="Icono de vehículo"
        class="h-8 w-auto"
        width="32"
        height="32"
        loading="lazy"
      />
    </div>
    <div class="col-span-10 flex items-center">
      {{ vehiculo.alias }}
    </div>
    <button
      class="col-span-1 flex items-center justify-center group cursor-pointer"
      (click)="eliminarVehiculo(vehiculo)"
      [attr.aria-label]="'Eliminar vehículo {{ vehiculo.alias }}'"
    >
      <i
        class="pi pi-trash text-appBlue group-hover:text-allasRed"
        aria-hidden="true"
      ></i>
    </button>
  </article>
</ng-template>

<ng-template #actionButtonsTemplate>
  <section
    class="bg-gray-50 pt-8 flex flex-col xl:flex-row gap-2 items-center justify-center w-full mb-24 pb-6"
  >
    <button
      class="border rounded-sm p-2 px-4 hover:border-gray-300 transition-colors fs-condensed xl:text-xl flex items-center justify-center"
      (click)="continuarSinVehiculo()"
      [attr.aria-label]="'Continuar comprando sin seleccionar vehículo'"
    >
      COMPRAR SIN VEHÍCULO
    </button>
    <button
      class="border rounded-sm p-2 px-4 bg-appPrimary-500 text-white hover:bg-appPrimary-300 hover:border-gray-300 transition-colors fs-condensed xl:text-xl flex items-center justify-center gap-2"
      (click)="agregarVehiculo()"
      [attr.aria-label]="'Agregar nuevo vehículo'"
    >
      <lucide-icon
        [name]="plusIcon"
        class="w-4 h-4"
        aria-hidden="true"
      ></lucide-icon>
      AGREGA UN VEHÍCULO
    </button>
  </section>
</ng-template>
